import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPhotoCamera$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPhotoCamera extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '16c0e2270551faa11787248d9d381730f6cb944a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f699c7d46be8cae665b51ef40c859d21055d2164', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f37fddd28950f17fbdef758f58092f9b861fe715', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.309 4a.5.5 0 0 0-.447.276L7 6H3.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H15l-.862-1.724A.5.5 0 0 0 13.691 4zm4.764 1.5.862 1.724a.5.5 0 0 0 .447.276H17.5v9h-13v-9h3.118a.5.5 0 0 0 .447-.276L8.927 5.5zM11 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-photo-camera", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-photo-camera"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-photo-camera":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPhotoCamera$1);
            }
            break;
    } });
}

const CosmosIconPhotoCamera = CosmosIconPhotoCamera$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPhotoCamera, defineCustomElement };
